<template>
    <div class="w-100">
        <loader-component v-if="loading" />
        <div v-else-if="error">
            {{ error }}
        </div>
        <div v-else>
            <div v-if="restaurants.length === 0" class="alert alert-info m-4">
                Aucun établissement n'est disponible pour le module commande à table.
            </div>
            <div v-else class="row m-0 pt-5 p-4">
                <restaurant-card
                    @click="showBoardForRestaurant($event.id)"
                    v-for="(restaurant, index) in restaurants"
                    :key="index"
                    :restaurant="restaurant"
                    class="col-md-4 mb-3" />
            </div>
        </div>
    </div>
</template>

<script>
import LoaderComponent from "../../../components/LoaderComponent.vue";
import RestaurantCard from "../../Default/Restaurants/RestaurantCard";

export default {
    name: "ClickAndCollectListRestaurants",
    data() {
        return {
            error: null,
            loading: false,
        };
    },
    created() {
        if (this.restaurants && this.restaurants.length === 1) {
            this.$router.push({
                name: "ordering_table.restaurants.board",
                params: { restaurant_id: this.restaurants[0].id },
            });
        }
    },
    methods: {
        showBoardForRestaurant(restaurant_id) {
            this.$router.push({ name: "ordering_table.restaurants.board", params: { restaurant_id } });
        },
    },
    computed: {
        restaurants() {
            return this.$store.getters["restaurants/getOrderingTableRestaurants"]();
        },
    },
    components: {
        LoaderComponent,
        RestaurantCard,
    },
};
</script>
